import { track } from '#/utils/analytics';
import { appendCampaignToUrl } from '#/utils/campaignContext';

export interface CtaLinkProps {
  href: string | undefined;
  onClick: () => void;
}

/**
 * The single seam between landing UI and tracking infrastructure.
 *
 * Bundles the two side concerns every CTA needs:
 *  - carry campaign context (UTM + template_code) across the origin hop
 *  - emit Amplitude `service_conversion_sub` on click, when an event key exists
 *
 * Presentational components call only this, never `#/utils/analytics` or
 * `#/utils/campaignContext` directly — so a consumer without that
 * infrastructure (e.g. the landing-only renderer in
 * `services/gov-benefit-landing-page`) can swap this one module for an
 * identity/no-op version and reuse the components verbatim.
 *
 * Deliberately a plain function, not a hook: `InlineLinks` resolves links
 * inside a `.map()`, where the rules of hooks forbid a hook call.
 */
export function ctaLinkProps(href?: string, eventKey?: string): CtaLinkProps {
  return {
    href: href ? appendCampaignToUrl(href) : undefined,
    onClick: () => {
      if (!eventKey) return;
      track('service_conversion_sub', { event_key: eventKey });
    },
  };
}
